export default __webpack_public_path__ + "static/media/reject-orange.7f1075f9.svg";